<template>
  <div v-if="this.$store.state.produto.nome">
<template>
  <nav class=" cor-primaria-bg">
    <div class="container nav-wrapper  ">
<!--        <button class="btn waves-effect waves-light" @click="voltar">-->
<!--          <i style="margin-left: 1px; margin-top: -10px" class="material-icons md-30">arrow_back</i>-->
<!--        </button>-->
      &nbsp;&nbsp;
      <a class="left" @click="voltar">
        <i class="material-icons" :style="'margin-left: 5px; font-size: 27px; color: #fff'">arrow_back</i>
      </a>
      <a class="right" @click="compartilhar">
        <i class="material-icons" :style="'font-size: 27px; color: #fff;margin-right: 5px;'">share</i>
      </a> &nbsp;&nbsp;
    </div>
  </nav>

</template>
<div id="myModalImageProduto" class="modalImageProduto" @click="closeModalImage()">
  <span class="close" @click="closeModalImage()"  >&times;</span>
  <PinchZoom class="zoom-container" overflow="visible" >
      <img class="modal-content" id="img01" :src="imagemAdicionalModal" alt="Imagem produto">
  </PinchZoom>
</div>
  <!--  <menu-superior
      :link="'/' + this.$store.state.empresa_url + '/menu'"
      titulo="Detalhes"
    ></menu-superior> -->
    <!--    <nav class=" cor-primaria-bg">-->
    <!--      <div class="container nav-wrapper ">-->
    <!--        <div replace class="left" @click="$router.go(-1)">-->
    <!--          <i style="margin-left: 8px" class="material-icons md-30">arrow_back</i>-->
    <!--        </div>-->
    <!--        <span style="padding-left: 15px; font-weight: bold">Detalhes</span>-->
    <!--      </div>-->
    <!--    </nav>-->
    <bloco>
      <div
        align="center"
        class="container"
        v-if="this.$store.state.produto.foto"
      >
        <img
          style="width: 100%"
          v-lazy="this.$store.state.produto.produto_imagem"
          data-loading="../../assets/loading.gif"
          :alt="this.$store.state.produto.nome"
          @click="openModalImage('')"
        />
        <!-- <img style="width: 100%" :src="this.$store.state.produto.produto_imagem" :alt="this.$store.state.produto.nome" class=" materialboxed"> -->
      </div>
      <br />
      <div class="itemb">
        <h2 class="titulo-item">
          {{ this.$store.state.produto.nome.toLocaleUpperCase() }}
        </h2>
      </div>
      <div class="itemb">
        <p v-if="this.$store.state.produto.descricao" class="titulo-descricao" v-html="formatarDescricao(this.$store.state.produto.descricao)">
        </p>
      </div>
      <div class="itemb">
        <p
          class="titulo-descricao"
          :style="(
              this.$store.state.produto.controlar_estoque == 'S' && this.$store.state.produto.quantidade > 0
            )
            ? {'color': 'green', 'font-size': 'medium'}
            : {'color': 'red', 'font-size': 'medium'}"
        >
          <!-- conteúdo do <p> -->
        </p>

        <p>
          <i class="material-icons tiny">local_mall</i>
          {{
            this.$store.state.produto.controlar_estoque == 'N'
              ? 'Disponível'
              : this.$store.state.empresa.ocultar_saldo == 'N'
                ? this.$store.state.produto.quantidade
                : ''
          }}
          {{
            this.$store.state.produto.controlar_estoque == 'N'
              ? ''
              : this.$store.state.produto.quantidade > 0
                ? this.$store.state.empresa.ocultar_saldo == 'N'
                  ? 'itens disponíveis'
                  : 'Disponível'
                : 'item indisponível'
          }}
        </p>


        <!-- <p
          v-else="this.$store.state.produto.controlar_estoque == 'S' && this.$store.state.empresa.ocultar_saldo == 'S'"
          class="titulo-descricao" style="color:red; font-size: medium;"
        >
          <i class="material-icons tiny">local_mall</i>
          {{
            this.$store.state.produto.quantidade > 1
              ? "itens disponíveis"
              : "item indisponível"
          }}
        </p>         -->
      </div>
      <div class="itemb">
        <p
          v-if="this.$store.state.produto.somente_retirada == 'S'"
          class="titulo-descricao"
        >
          <i class="material-icons tiny">info</i> Disponivel somente para
          retirada.
        </p>
      </div>
      <div class="itemb">
        <div class="titulo-valor" style="margin-bottom: 2px">
          <span class="price-new">
            <strong
              style="font-size: medium"
              v-if="this.$store.state.produto.promocao == 'S'"
              >R${{ this.$store.state.produto.valor_promocional }}</strong
            >
            <strike
              style="font-size: small"
              v-if="this.$store.state.produto.promocao == 'S'"
              >R${{ this.$store.state.produto.valor_real }}</strike
            >
            <strong
              style="font-size: medium"
              v-if="this.$store.state.produto.promocao == 'N'"
              >R${{ this.$store.state.produto.valor }}</strong
            >
          </span>
        </div>
        <!--
        <p v-if="this.$store.state.produto.valor != '0.00'" class="titulo-valor">
          <span>R$ {{ this.$store.state.produto.valor }}</span>
        </p>-->
      </div>
    </bloco>
    <bloco v-if="this.$store.state.produto.categorias.length > 0">
      <div
        v-for="categoria in this.$store.state.produto.categorias"
        :key="categoria.id"
      >
        <titulo-destacado
          :titulo="categoria.nome"
          :descricao="categoria.descricao"
        >
          <div v-if="categoria.limitar == 'S'" class="tb-fit">
            <span class="badge cor-primaria-bg"
              >{{ categoria.quantidade }} | {{ categoria.maximo }}</span
            >
          </div>
          <div v-if="categoria.obrigatorio == 'S'" class="tb-fit">
            <span
              v-if="!validarCategoria(categoria)"
              class="badge cor-primaria-bg"
              >Obrigatório</span
            >
            <span v-else class="material-icons md-30 cor-primaria-text"
              >check_circle_outline</span
            >
          </div>
        </titulo-destacado>

        <div
          class="tb cor-primaria-divider"
          v-for="adicional in categoria.adicionais"
          :key="adicional.id"
        >
          <div class="tb-fill">
            <div class="row">
              <div class="col s4" v-if="adicional.foto">
                <div
                  v-if="adicional.foto"
                  class="col s12"
                  style="padding: 0px"

                >
                <!-- class="modal-trigger" href="#modal1" -->
                  <a @click="openModalImage(adicional.adicional_imagem)">
                    <img
                      class=""
                      data-caption=""
                      width="100%"
                      :src="adicional.adicional_imagem"
                    />
                  </a>
                </div>
              </div>
              <div class="col">
                {{ adicional.nome }}
                <div v-if="adicional.descricao" class="adicional-descricao">
                  {{ adicional.descricao }}
                </div>
                <br v-else />
                <span class="adicional-valor" v-if="adicional.valor != '0.00'">
                  <span class="mais">+</span>
                  R$ {{ adicional.valor }}
                  <strike style="font-size: 10px" v-if="adicional.promocao == 'S'">R$ {{ adicional.valor_original }}</strike>
                </span>
              </div>
            </div>
          </div>

          <div class="tb-fit text-bold">
            <span
              v-if="adicional.quantidade"
              @click="removerItemDeCategorias(categoria, adicional)"
              class="btn waves-effect waves-light cor-primaria-bg"
            >
              <i class="material-icons md-18">remove</i>
            </span>
            <span v-if="adicional.quantidade" class="btn btn-flat disabled">
              <span class="grey-text text-darken-4">{{
                adicional.quantidade
              }}</span>
            </span>
            <span
              @click="adicionarItemDeCategorias(categoria, adicional)"
              :class="
                'btn waves-effect waves-light cor-primaria-bg' +
                ((adicional.limitar == 'S' &&
                  adicional.quantidade >= adicional.maximo) ||
                (categoria.limitar == 'S' &&
                  categoria.quantidade >= categoria.maximo)
                  ? ' disabled'
                  : '')
              "
            >
              <i class="material-icons md-18">add</i>
            </span>
          </div>
        </div>
      </div>
    </bloco>
    <bloco v-else-if="this.$store.state.produto.adicionais.length > 0">
      <titulo-destacado titulo="Adicionais"></titulo-destacado>

      <div
        v-for="adicional in this.$store.state.produto.adicionais"
        :key="adicional.id"
        class="tb cor-primaria-divider"
      >
        <div class="tb-fill">
          {{ adicional.nome }}
          <div v-if="adicional.descricao" class="adicional-descricao">
            {{ adicional.descricao }}
          </div>
        </div>
        <div class="tb-fit">
          <label
            class="adicional-valor checkbox-rtl grey-text text-darken-4 right"
          >
            <input
              type="checkbox"
              v-model="item.adicionais"
              :value="adicional"
              @click="check($event, adicional)"
              class="filled-in"
            />
            <span>R$ {{ adicional.valor }}</span>
            <span class="mais">+</span>
          </label>
        </div>
      </div>
    </bloco>
    <bloco>
      <titulo-destacado titulo="Alguma observação?"></titulo-destacado>
      <div class="input-field col s12">
        <textarea
          v-model="item.observacao_cliente"
          placeholder="Digite aqui sua observação"
          id="observacao"
          class="materialize-textarea"
          maxlength="150"
          data-length="150"
        ></textarea>
      </div>
    </bloco>
    <!-- Modal Structure Recomendação -->
    <div
      id="modal-recomendacao"
      class="modal"
      v-if="Number(this.$store.state.produto.produto_id_relacionado)"
    >
      <div class="modal-content" style="padding: 0px">
        <div align="center">
          <div class="cor-primaria-bg">
            <div
              style="
                font-size: 20px;
                font-weight: bold;
                padding: 10px;
                color: white;
              "
            >
              Sugestão da Casa
            </div>
          </div>
          <br />
          <div style="width: 100%; height: 3px"></div>
          <img
            width="100"
            :src="
              this.$store.state.produto.produto_relacionado
                .produto_imagem_preview
            "
            class="circle responsive-img"
          />
          <div style="width: 100%; height: 10px"></div>
          <div style="font-size: 18px; font-weight: bold">
            {{ this.$store.state.produto.produto_relacionado.nome }}
          </div>
          <div style="font-size: 18px">
            R$ {{ this.$store.state.produto.produto_relacionado.valor }}
          </div>
          <br />

          <div
            :class="'btn waves-effect waves-light cor-primaria-bg'"
            @click="visualizarRecomendacao()"
          >
            Visualizar Produto
          </div>
          <br />
          <div style="height: 5px"></div>
          <div
            :class="'btn waves-effect waves-light '"
            style="background-color: gray"
            @click="exit()"
          >
            Agora não
          </div>
          <div style="height: 30px"></div>
        </div>
      </div>
    </div>

    <div style="padding-top: 100px">
      <!--aberto-->
      <caixa-flutuante-inferior
        v-if="this.$store.state.empresa.aberto == 'S' || this.$store.state.empresa.habilitar_agendamento_fechada == 'S'"
        altura="60"
        estilo="font-weight: bold; background-color: white; max-width: 800px; padding: 0"
      >
        <div class="tb">
          <span v-if="this.$store.state.empresa.bloquear_pedido === 'S'" class="tb-fit right"
          style="display: flex; justify-content: center; color: red; font-weight: bold; width: 100%;">
            Chame o Garçom!
          </span>
          <div v-if="this.$store.state.empresa.bloquear_pedido != 'S'" class="tb-fit">
            <span
              @click="atualizarQuantidade(false)"
              class="btn waves-effect waves-light cor-primaria-bg"
              ><i class="material-icons md-18">remove</i></span
            >
            <span class="btn btn-flat disabled"
              ><span class="grey-text text-darken-4"
                >{{ item.quantidade }}
              </span></span
            >
            <span
              @click="atualizarQuantidade(true)"
              class="btn waves-effect waves-light cor-primaria-bg"
              ><i class="material-icons md-18">add</i></span
            >
          </div>
          <div v-if="!garantirCompra()">
            <span

              :class="
                // 'btn waves-effect waves-light cor-primaria-bg' +
                (!verificarCategorias() ? ' disabled' : '')
              "
              disabled="true"
            >
              indisponível
              <span style="margin-left: 8px"
                >R$
                {{
                  0
                }}</span
              >
            </span>
          </div>
          <div v-else class="tb-fit right">
            <span v-if="this.$store.state.empresa.bloquear_pedido != 'S'"

              @click="adicionarPedido()"
              :class="
                'btn waves-effect waves-light cor-primaria-bg' +
                (!verificarCategorias() ? ' disabled' : '')
              "
            >
              Adicionar
              <span style="margin-left: 8px"
                >R$
                {{
                  (total_itens_com_adicionais * item.quantidade).toFixed(2)
                }}</span
              >
            </span>
          </div>
        </div>
      </caixa-flutuante-inferior>
      <!--    fechado-->
      <caixa-flutuante-inferior
        v-else
        altura="130"
        estilo="background-color: white; color: black; max-width: 800px"
      >
        <span style="width: 100%">
          <h6 class="center-align" style="margin: 3px">Restaurante Fechado!</h6>
          <p
            class="center-align"
            style="padding: 3px; margin: 5px; font-size: 13px"
          >
            No momento, não estamos aceitando novos pedidos.
          </p>
          <a
            class="waves-effect waves-light btn btn-large disabled"
            style="width: 100%"
            >Adicionar</a
          >
        </span>
      </caixa-flutuante-inferior>
    </div>
  </div>
</template>

<script>
import TituloDestacado from "../Widgets/TituloDestacado";
import Bloco from "../Widgets/Bloco";
import MenuSuperior from "../Widgets/MenuSuperior";
import CaixaFlutuanteInferior from "../Widgets/CaixaFlutuanteInferior";
import Swal from "sweetalert2";
import SecureLS from "secure-ls";
import PinchZoom from 'vue-pinch-zoom';
export default {
  name: "Produto",
  data() {
    return {
      imagemAdicionalModal: "",
      item: {
        id: 0,
        nome: "",
        valor: 0,
        codigo_local: 0,
        quantidade: 1,
        adicionais: [],
        observacao_cliente: "",
      },
      total_itens_com_adicionais: parseFloat(this.$store.state.produto.valor),
    };
  },
  components: { CaixaFlutuanteInferior, MenuSuperior, Bloco, TituloDestacado, PinchZoom },
  beforeMount() {
    var empresa_url = this.$router.currentRoute.params.empresa;
    this.$store.commit("empresaUrl", empresa_url);

    if (!this.$store.state.produto.nome) {
      this.$router.push("/" + this.$store.state.empresa_url);
      return;
    }

    this.$store.state.produto.adicionais.forEach((a) => {
      a.produto_adicional_cat_id = 0;
      a.cat_nome = "Adicionais";
      a.quantidade = 1;
    });

    this.$store.state.produto.categorias.forEach((c) => {
      c.quantidade = 0;
      c.maiorValor = 0;
      c.adicionais.forEach((a) => {
        a.quantidade = 0;
        a.obrigatorio = c.obrigatorio;
      });
    });
  },
  mounted() {
    window.scrollTo(0, 0);
    $(".materialboxed").materialbox();
    $("#observacao").characterCounter();
    $(".modal").modal();

    if (this.$store.state.empresa.usa_facebook_pixel == "S") {
      fbq(fbq.track, "ViewContent" + fbq.src, {
        content_category: this.$store.state.produto.grupo_nome,
        content_type: "product",
        content_ids: ["produto_" + this.$store.state.produto.id],
        content_name: this.$store.state.produto.nome,
        value: parseFloat("0" + this.$store.state.produto.valor),
        currency: "BRL",
      });
    }

    gtag("event", "view_item", {
      items: [
        {
          item_id: "produto_" + this.$store.state.produto.id,
          item_name: this.$store.state.produto.nome,
          item_category: this.$store.state.produto.grupo_nome,
          currency: "BRL",
          price: parseFloat("0" + this.$store.state.produto.valor),
        },
      ],
    });
  },
  methods: {
    voltar(){
      this.$router.push("/" + this.$store.state.empresa_url + "/menu");
    },
    async compartilhar()
    {
      const currentUrl = window.location.href;
      const productId = currentUrl.split('/').pop();
      const newUrl = "/" + this.$store.state.empresa_url + "/menu?produto=" + productId;
      if (navigator.share)
      {
        this.compartilharComImagem(newUrl);
      } else {
        this.copiarParaAreaDeTransferencia(location.origin + newUrl);
      }
    },
    async compartilharComImagem(newUrl) {
      navigator.share({
        title: 'Compartilhar',
        text: this.$store.state.produto.nome.toLocaleUpperCase(),
        url: newUrl
      })
        .then(() => console.log('Successful share'))
        .catch((error) => console.error('Error sharing:', error));
    },
    copiarParaAreaDeTransferencia(texto) {
      const el = document.createElement('textarea');
      el.value = texto;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      Swal.fire({
        icon: 'success',
        title: 'Link copiado!',
        text: 'Agora você já pode compartilhar este produto :)'
      });
    },
    formatarDescricao(descricao) {
      return descricao.replace(/\n/g, '<br>');
    },
    selecionarImagem(link) {
      this.imagemAdicionalModal = link;
    },
    garantirCompra(){

      if (this.$store.state.produto.controlar_estoque == 'S' && this.$store.state.produto.pausar_estoque_zero == 'S' && this.$store.state.produto.quantidade <= 0) {
        return false
      } else
        return true
    },
    adicionarItemDeCategorias(categoria, adicional) {
      if (
        categoria.limitar == "S" &&
        categoria.quantidade >= categoria.maximo
      ) {
        M.toast({ html: "Limite máximo atingido", displayLength: 3000 });
        return;
      }

      if (
        adicional.limitar == "S" &&
        adicional.quantidade >= adicional.maximo
      ) {
        M.toast({ html: "Limite máximo atingido", displayLength: 3000 });
        return;
      }

      var fator = adicional.fator_acrescimo ? adicional.fator_acrescimo : 1;
      if (adicional.usa_fator_acrescimo == "S") {
        fator = adicional.fator_acrescimo ? adicional.fator_acrescimo : 1;
      } else {
        fator = 1;
      }

      if (adicional.minimo > 0 && adicional.quantidade < adicional.minimo) {
        if (
          categoria.limitar == "S" &&
          categoria.quantidade + adicional.minimo > categoria.maximo
        ) {
          M.toast({ html: "Limite máximo atingido", displayLength: 3000 });
          return;
        }
      } else {
        if (
          categoria.limitar == "S" &&
          categoria.quantidade + fator > categoria.maximo
        ) {
          M.toast({ html: "Limite máximo atingido", displayLength: 3000 });
          return;
        }
      }
      //

      adicional.cat_nome = categoria.nome;

      if (adicional.minimo > 0 && adicional.quantidade < adicional.minimo) {
        if (fator) {
          if (fator > adicional.minimo) {
            adicional.quantidade = adicional.quantidade + fator;
            categoria.quantidade = categoria.quantidade + fator;
          } else {
            adicional.quantidade = adicional.quantidade + adicional.minimo;
            categoria.quantidade = categoria.quantidade + adicional.minimo;
          }
        } else {
          adicional.quantidade = adicional.quantidade + adicional.minimo;
          categoria.quantidade = categoria.quantidade + adicional.minimo;
        }
      } else {
        adicional.quantidade = adicional.quantidade + fator;
        categoria.quantidade = categoria.quantidade + fator;
      }
      //

      if (
        this.$store.state.empresa.pizza_maior_preco == "S" &&
        categoria.pizza_tamanho_id
      ) {
        if (parseFloat(adicional.valor) > categoria.maiorValor) {
          categoria.maiorValor = parseFloat(adicional.valor);

          for (let i = 0; i < categoria.adicionais.length; i++) {
            if (
              categoria.maiorValor > parseFloat(categoria.adicionais[i].valor)
            ) {
              if (!categoria.adicionais[i].original)
                categoria.adicionais[i].original =
                  categoria.adicionais[i].valor;

              if (categoria.adicionais[i].quantidade > 0)
                this.decrementarValorTotal(
                  categoria.adicionais[i].valor *
                    categoria.adicionais[i].quantidade
                );

              categoria.adicionais[i].valor = categoria.maiorValor.toFixed(2);

              if (categoria.adicionais[i].quantidade > 0)
                this.incrementarValorTotal(
                  categoria.adicionais[i].valor *
                    categoria.adicionais[i].quantidade
                );
            }
          }
        }
      }

      if (!this.item.adicionais.includes(adicional))
        this.item.adicionais.push(adicional);

      if (adicional.minimo > 0 && adicional.quantidade <= adicional.minimo) {
        this.incrementarValorTotal(adicional.valor, adicional.quantidade);
      } else {
        this.incrementarValorTotal(adicional.valor);
      }
    },
    removerItemDeCategorias(categoria, adicional) {
      if (!adicional.quantidade) return;

      var fator = adicional.fator_acrescimo ? adicional.fator_acrescimo : 1;
      if (adicional.usa_fator_acrescimo == "S") {
        fator = adicional.fator_acrescimo ? adicional.fator_acrescimo : 1;
      } else {
        fator = 1;
      }

      if (
        adicional.minimo > 0 &&
        adicional.quantidade - adicional.minimo != 0
      ) {
        adicional.quantidade = adicional.quantidade - fator;
        categoria.quantidade = categoria.quantidade - fator;
      } else {
        if (adicional.quantidade - adicional.minimo == adicional.quantidade) {
          adicional.quantidade = adicional.quantidade - fator;
          categoria.quantidade = categoria.quantidade - fator;
        } else {
          if (adicional.minimo > fator) {
            adicional.quantidade = adicional.quantidade - adicional.minimo;
            categoria.quantidade = categoria.quantidade - adicional.minimo;
          } else {
            adicional.quantidade = adicional.quantidade - fator;
            categoria.quantidade = categoria.quantidade - fator;
          }
        }
      }
      //

      if (adicional.quantidade == 0) {
        if (
          this.$store.state.empresa.pizza_maior_preco == "S" &&
          categoria.pizza_tamanho_id
        ) {
          if (!adicional.original) {
            categoria.maiorValor = 0;

            for (let i = 0; i < categoria.adicionais.length; i++) {
              if (
                categoria.adicionais[i].quantidade > 0 &&
                parseFloat(categoria.adicionais[i].original) >
                  categoria.maiorValor
              )
                categoria.maiorValor = parseFloat(
                  categoria.adicionais[i].original
                );
            }

            for (let i = 0; i < categoria.adicionais.length; i++) {
              if (
                categoria.maiorValor >=
                parseFloat(categoria.adicionais[i].original)
              ) {
                if (categoria.adicionais[i].quantidade > 0)
                  this.decrementarValorTotal(
                    categoria.adicionais[i].valor *
                      categoria.adicionais[i].quantidade
                  );

                categoria.adicionais[i].valor = categoria.maiorValor.toFixed(2);

                if (categoria.adicionais[i].quantidade > 0)
                  this.incrementarValorTotal(
                    categoria.adicionais[i].valor *
                      categoria.adicionais[i].quantidade
                  );
              }

              if (
                categoria.maiorValor <=
                parseFloat(categoria.adicionais[i].original)
              ) {
                categoria.adicionais[i].valor =
                  categoria.adicionais[i].original;
                categoria.adicionais[i].original = null;
              }
            }
          }
        }

        var index = this.item.adicionais.indexOf(adicional);
        if (index >= 0) this.item.adicionais.splice(index, 1);
      }

      //this.decrementarValorTotal(adicional.valor);
      //
      if (adicional.minimo > 0 && adicional.quantidade - adicional.minimo >= 0)
        this.decrementarValorTotal(adicional.valor);
      else this.decrementarValorTotal(adicional.valor, adicional.minimo);
      //
    },
    atualizarQuantidade(mais) {
      if (mais && this.$store.state.produto.controlar_estoque == "S") {
        if (this.item.quantidade >= this.$store.state.produto.quantidade) {
          alert("Limite máximo atingido");
          return false;
        }
      }

      if (mais) this.item.quantidade++;
      else if (this.item.quantidade > 1) this.item.quantidade--;
    },
    incrementarValorTotal(valor, qtd = 0) {
      if (valor != "0.00") {
        if (qtd > 0) {
          this.total_itens_com_adicionais =
            this.total_itens_com_adicionais + parseFloat(valor * qtd);
        } else {
          this.total_itens_com_adicionais =
            this.total_itens_com_adicionais + parseFloat(valor);
        }
      } else {
        this.total_itens_com_adicionais =
          this.total_itens_com_adicionais + 0.01;
        this.total_itens_com_adicionais =
          this.total_itens_com_adicionais - 0.01;
      }
    },
    decrementarValorTotal(valor, qtd = 0) {
      if (valor != "0.00") {
        if (qtd > 0) {
          this.total_itens_com_adicionais =
            this.total_itens_com_adicionais - parseFloat(valor * qtd);
        } else {
          this.total_itens_com_adicionais =
            this.total_itens_com_adicionais - parseFloat(valor);
        }
        //
      } else {
        this.total_itens_com_adicionais =
          this.total_itens_com_adicionais - 0.01;
        this.total_itens_com_adicionais =
          this.total_itens_com_adicionais + 0.01;
      }
    },
    validarCategoria(categoria) {
      if (categoria.limitar == "S" && categoria.obrigatorio == "S")
        return (
          categoria.quantidade >= categoria.minimo && categoria.quantidade > 0
        );

      if (categoria.limitar == "S" && categoria.quantidade >= categoria.minimo)
        return true;

      if (categoria.obrigatorio == "S" && categoria.quantidade > 0) return true;

      return false;
    },
    verificarCategorias() {
      var categorias = [];
      categorias = this.$store.state.produto.categorias;

      return categorias.every((cat) => {
        if (cat.obrigatorio == "S") {
          if (!cat.quantidade) return false;

          if (cat.quantidade < cat.minimo) return false;
        }

        return true;
      });
    },
    beforeExit() {
      if (Number(this.$store.state.produto.produto_id_relacionado)) {
        $(document).ready(function () {
          $("#modal-recomendacao").modal("open");
        });
      } else {
        this.$router.go(-1);
      }
    },
    exit() {
      $(document).ready(function () {
        $("#modal-recomendacao").modal("close");
      });
      this.$router.go(-1);
    },
    visualizarRecomendacao() {
      $(document).ready(function () {
        $("#modal-recomendacao").modal("close");
      });
      this.$router.go(-1);
      let produto_id_relacionado =
        this.$store.state.produto.produto_id_relacionado;
      setTimeout(() => {
        document.getElementById("produtoid-" + produto_id_relacionado).click();
      }, 500);
    },
    adicionarPedido() {
      if (!this.verificarCategorias()) {
        M.toast({
          html: "Informe todos os adicionais obrigatórios",
          displayLength: 3000,
        });
        return;
      }
      const generateRandomInt = (min, max) =>
        Math.floor(Math.random() * (max - min)) + min;

      // Recupere o código do produto
      // let codigoProduto = this.$store.state.produto.id;

      // Verifique se já existe um item no carrinho com o mesmo código
      // let itemExistente = this.$store.state.pedido.itens.find(item => item.id === codigoProduto);
      let adicionaisPresentes = this.item.adicionais.length > 0;

      if (adicionaisPresentes && !this.item.observacao_cliente) {
        let observacao = ".";
        this.item.observacao_cliente = observacao;
      }

      this.item.id = this.$store.state.produto.id;
      this.item.valor = this.$store.state.produto.valor;
      this.item.somente_retirada = this.$store.state.produto.somente_retirada;
      this.item.nome = this.$store.state.produto.nome;
      this.item.codigo_local = generateRandomInt(11111, 99999);
      this.item.permite_cupom_desconto = this.$store.state.produto.permite_cupom_desconto || 'S'; // Se não existir, assume que permite
      this.$store.commit("adicionar_item_pedido", this.item);

      // this.item.id = this.$store.state.produto.id;
      // this.item.valor = this.$store.state.produto.valor;
      // this.item.somente_retirada = this.$store.state.produto.somente_retirada;
      // this.item.nome = this.$store.state.produto.nome;
      // this.item.codigo_local = generateRandomInt(11111, 99999);
      // this.$store.commit("adicionar_item_pedido", this.item);

      if (this.$store.state.empresa.usa_facebook_pixel == "S") {
        var fbqContents = [];

        fbqContents.push({
          id: "produto_" + this.$store.state.produto.id,
          name: this.$store.state.produto.nome,
          quantity: this.$store.state.produto.quantidade,
          value: parseFloat("0" + this.$store.state.produto.valor),
        });

        this.item.adicionais.forEach((ad) => {
          fbqContents.push({
            id: "adicional_" + ad.adicional_id,
            name: ad.nome,
            quantity: this.$store.state.produto.quantidade * ad.quantidade,
            value: parseFloat("0" + ad.valor),
          });
        });

        fbq(fbq.track, "AddToCart" + fbq.src, {
          content_category: this.$store.state.produto.grupo_nome,
          content_type: "product",
          contents: fbqContents,
          value: parseFloat("0" + this.total_itens_com_adicionais),
          currency: "BRL",
        });
      }

      var gtagItens = [];

      gtagItens.push({
        item_id: "produto_" + this.$store.state.produto.id,
        item_name: this.$store.state.produto.nome,
        item_category: this.$store.state.produto.grupo_nome,
        quantity: this.$store.state.produto.quantidade,
        currency: "BRL",
        price: parseFloat("0" + this.$store.state.produto.valor),
      });

      this.item.adicionais.forEach((ad) => {
        gtagItens.push({
          item_id: "adicional_" + ad.adicional_id,
          item_name: ad.nome,
          quantity: this.$store.state.produto.quantidade * ad.quantidade,
          currency: "BRL",
          price: parseFloat("0" + ad.valor),
        });
      });

      gtag("event", "add_to_cart", { items: gtagItens });

      Swal.fire({
        icon: "success",
        iconHtml:
          '<span class="material-icons md-48 success">add_shopping_cart</span>',
        titleText: "Adicionado!",
        html: "Item adicionado ao seu pedido!",
        customClass: { confirmButton: "confirm-button-class cor-primaria-bg" },
      })
        .then((res) => {
          this.beforeExit();
        })
        .catch((res) => {
          this.$router.go(-1);
          //this.$router.push('/' + this.$store.state.empresa_url + '/menu');
        });
    },
    check: function (e, adi) {
      if (e.target.checked)
        this.total_itens_com_adicionais =
          this.total_itens_com_adicionais + parseFloat(adi.valor);
      else
        this.total_itens_com_adicionais =
          this.total_itens_com_adicionais - parseFloat(adi.valor);
    },
    openModalImage(image){

        if(image){
          this.imagemAdicionalModal =  image;
        } else {
          this.imagemAdicionalModal =  this.$store.state.produto.produto_imagem;
        }

        let modalImage = document.getElementById('myModalImageProduto');
        modalImage.style.display = 'flex';
    },
    closeModalImage(){
        let modalImage = document.getElementById('myModalImageProduto');
        modalImage.style.display = 'none';
        this.imagemAdicionalModal =  '';
    },
  },
};
</script>

<style scoped>
h2 {
  font-size: 3.5rem;
  line-height: 110%;
  margin: 0;
}

.bloco {
  padding: 0px 10px;
}

.tb {
  border-bottom: 1px solid;
}

.tb:last-child {
  margin-bottom: 8px;
}

.tb .tb-fill .adicional-descricao {
  font-size: 0.85em;
  color: #7f8f9f;
}

.tb .tb-fill .adicional-valor {
  font-size: 1em;
  font-weight: bold;
}

.tb .tb-fit .adicional-valor {
  font-size: 1em;
  margin-right: 4px;
}

.tb .tb-fill .adicional-valor .mais {
  font-size: 1.1em;
  padding-right: 4px;
}

.tb .tb-fill .adicional-valor .valor-original {
  margin-left: 4px;
  text-decoration: line-through;
  color: #7f8f9f;
  font-weight: normal;
}

.checkbox-rtl {
  direction: rtl;
  margin-right: 0px !important;
}

/*CheckBox R2L*/
.checkbox-rtl [type="checkbox"] + span:not(.lever) {
  padding-right: 28px;
  padding-left: 4px;
}

.checkbox-rtl
  [type="checkbox"].filled-in:not(:checked)
  + span:not(.lever):before,
.checkbox-rtl [type="checkbox"].filled-in:checked + span:not(.lever):before {
  right: 11px;
}

.checkbox-rtl
  [type="checkbox"].filled-in:not(:checked)
  + span:not(.lever):after,
.checkbox-rtl [type="checkbox"].filled-in:checked + span:not(.lever):after {
  right: 0;
}

.name {
  font-size: 0.65rem;
}

.description {
  /*line-height: 0.5rem;*/
  font-size: 0.6rem;
}

.price {
  font-size: 0.6rem;
}

.itemb {
  display: flex;
  flex-direction: row;
  -webkit-box-pack: start;
  justify-content: flex-start;
  -webkit-box-align: start;
  align-items: start;
}

.itemb .titulo-item {
  line-height: 2;
  font-size: 1.2rem;
  margin-bottom: 8px;
}

.itemb .titulo-descricao {
  line-height: 2;
  font-size: 0.9rem;
  margin-bottom: 8px;
}

.itemb .titulo-valor {
  line-height: 2;
  font-size: 1.2rem;
  margin-bottom: 8px;
}
.modalImageProduto {
  display: none;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  padding: 20px;
  padding-top: 50px;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.9);
  justify-content: center;
  align-items: center;

}
.modal-content {
    margin: auto;
    display: block;
    width: 100%;
    max-width: 700px;
    height: auto;
}

.close {
    position: absolute;
    top: 15px;
    right: 35px;
    color: #fff;
    font-size: 40px;
    font-weight: bold;
    transition: 0.3s;
}

.close:hover,
.close:focus {
    color: #bbb;
    text-decoration: none;
    cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/Paginas/Produto.vue